module.exports = __webpack_public_path__ + "assets/img/Balance.e423bcce.png";